<template>
  <div class="recharge_left capital_first">
    <el-row class="headerTopBg">
      <el-col :span="12">
        <h3>
          {{$t('account.timeTreasure')}}
          <span class="headerDetail"
            >{{ $t('timeBao.interestRateDesc') }}{{ annual_interest_rate }}%</span
          >
        </h3>
      </el-col>
    </el-row>
    <el-row class="headerTopBg">
      <el-tabs id="timeBaoTabs">
        <el-tab-pane id="isFromCoupon1">
          <h4 slot="label">{{ $t('timeBao.timeTresureBao') }}</h4>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <div class="values-bar">
                <el-row style="display: flex; align-items: center">
                  <el-col :span="4" class="capital">
                    <h5>{{$t('timeBao.currentAmount')}}</h5>
                    <p>
                      <span class="integer-value">{{ amount }}</span>
                      <span class="decimal-value">元</span>
                    </p>
                  </el-col>
                  <el-col :span="4" class="capital">
                    <h5>{{$t('timeBao.currentAssets')}}</h5>
                    <p>
                      <span class="integer-value">{{ interestthis }}</span>
                      <span class="decimal-value">元</span>
                    </p>
                  </el-col>
                  <el-col :span="4" class="capital" v-if="false">
                    <h5>{{$t('account.cumIncome')}}</h5>
                    <p>
                      <span class="integer-value">{{ interestamount }}</span>
                      <span class="decimal-value">元</span>
                    </p>
                  </el-col>
                  <el-col :span="4" class="capital">
                    <h5>{{ $t('timeBao.annualRate') }}</h5>
                    <p>
                      <span class="integer-value">{{ annual_interest_rate }}</span>
                      <span class="decimal-value">%</span>
                    </p>
                  </el-col>
                  <el-col
                    :span="8"
                    style="text-align: right; padding-right: 20px"
                  >
                    <el-button
                      @click="
                        moveInState = true;
                        moveInAmount = cash;
                      "
                      class="btn-white-bg"
                      size="small"
                      >转入</el-button
                    >
                    <el-button
                      @click="
                        moveOutState = true;
                        moveOutAmount = timebao_accout;
                      "
                      size="small"
                      class="btn-blue-bg"
                      >转出</el-button
                    >
                  </el-col>
                </el-row>
              </div>
            </div>
            <div style="text-align: left; padding-left: 20px">
              <img style="height: auto; width: 878px" :src="timebaoImage" />
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane id="isFromCoupon2">
          <h4 slot="label">{{$t('timeBao.bill')}}</h4>
          <el-card>
            <el-form :inline="true" size="mini">
              <el-form-item :label="$t('timeBaoDetails.date')"  id="inputField">
                <el-date-picker
                  v-model="timebaoDetails.date"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :range-separator="$t('system.to')"
                  :start-placeholder="$t('system.fromDate')"
                  :end-placeholder="$t('system.toDate')"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="getTimebaoDetails"
                  style="background: var(--baseColor); border-color: var(--baseColor);"
                  >{{$t('timeBaoDetails.retrieve')}}</el-button
                >
              </el-form-item>
            </el-form>
            <el-table
              :data="timebaoDetails.data"
              size="mini"
              stripe
              style="width: 100%"
            >
              <el-table-column prop="name" align="center" :label="$t('field.I118_name')">
              </el-table-column>
              <el-table-column prop="amount" align="center" :label="$t('field.UserSimulate_user_account_account')">
              </el-table-column>
              <el-table-column prop="balance" align="center" :label="$t('account.balance')">
              </el-table-column>
              <el-table-column prop="time" align="center" :label="$t('field.TimebaoLog_create_time')">
              </el-table-column>
            </el-table>
            <div class="changePage" style="padding-top: 15px">
              <el-button
                type="primary"
                icon="el-icon-arrow-left"
                @click="prevTimebao"
                size="mini"
                style="background: var(--baseColor); border-color: var(--baseColor);"
                >{{ $t('timeBao.previous') }}</el-button
              >
              <el-button
                type="primary"
                @click="nextTimebao"
                size="mini"
                style="float: right; background: var(--baseColor); border-color: var(--baseColor);"
              >
              {{ $t('timeBao.next') }}
              <i class="el-icon-arrow-right"></i>
              </el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-dialog
      class="timebao_popup"
      :title="$t('timeBao.transferIn')"
      :visible.sync="moveInState"
    >
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <h4 slot="label">{{$t('agentTransferWithdraw.balance')}}:</h4>
          <p>{{ cash }}{{$t('recharge.yuan')}}</p>
        </el-form-item>
        <el-form-item id="inputField">
          <h4 slot="label">{{$t('timeBao.transferAmount')}}:</h4>
          <el-input
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model="moveInAmount"
            placeholder=""
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="moveInState = false" class="dialog-cancel">{{$t('account.cancel')}}</el-button>
        <el-button type="primary" @click="movein" style="background-color: #ee5c35;border-color:#ee5c35">{{$t('trading.sure')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="timebao_popup"
      :title="$t('timeBao.transferOut')"
      :visible.sync="moveOutState"
    >
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <h4 slot="label">{{$t('timeBao.transferableBalance')}}:</h4>
          <p>{{ timebao_accout }}{{ $t('increaseInfo.yuan') }}</p>
        </el-form-item>
        <el-form-item id="inputField">
          <h4 slot="label">{{$t('timeBao.transferAmountBao')}}:</h4>
          <el-input
            oninput="value=value.replace(/[^\d.]/g,'')"
            v-model="moveOutAmount"
            placeholder=""
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="moveOutState = false">{{$t('trading.cancel')}}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="moveout">{{$t('trading.sure')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import { Loading } from 'element-ui';
    export default {
        name: "timebao",
      data(){
        return{
          amount:0,
          cash:0,
          timebao_accout:0,
          interestthis:0,
          interestamount:0,
          timebaoImage:"",
          moveInAmount:0,
          annual_interest_rate:0,
          moveOutAmount:null,
          moveInState:false,
          moveOutState:false,
          timebaoDetails: {
          date: [],
          data: [],
          page: 1,
          num: 20
        }
        }
      },
      computed:{
      },
      methods: {
       getTimebaoFund() {
            let that = this;
            that
            .$http({
                url: "/app/Timebao/query_fund",
                method: "get",
                data: {
              
                
                },
                transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
                if (res.data.status == 200) {
                  let resData = res;
                  that.account = resData.data.account;
                  that.amount = resData.data.account.amount;
                  that.interestthis = resData.data.account.interestthis;
                  that.interestamount = resData.data.account.interestamount;
                  // that.timebaoImage = resData.data.image;
                  that.annual_interest_rate = resData.data.annual_interest_rate;
                } else  {
                that.$message.error(that.$t(res.data.msgId));
                }
            });
      },

    getTimeBaoImage() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: "timebao_pc",
          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          console.log('eee',res.data);
          if (res.data.status == 200) {
            that.timebaoImage = res.data.data;
          }
        });
    },
    getTimebaoDetails(){
        
        let that = this;
        that
          .$http({
            url: "/app/Timebao/query_log",
            method: "post",
            data: {
              
              page: that.timebaoDetails.page,
              num:that.timebaoDetails.num,
              start: that.timebaoDetails.date?that.timebaoDetails.date[0]:'',
              end:that.timebaoDetails.date?that.timebaoDetails.date[1]:'',
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
          .then(function(res) {
            if (res.data.status == 200) {
              let resData = res.data;
              that.timebaoDetails.data = resData.data;
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      },
      //获取用户信息
    getUserinfo() {
      let that = this;
      that.$http({
        url: "/app/User/user",
        method: "post",
        data: {
          
        },
        transformRequest: [(data) => JSON.stringify(data)]
      })
        .then(function (res) {
          if (res.data.status == 200) {
            that.cash = res.data.data.cash;
            that.moveInAmount= that.cash;
            that.timebao_accout = res.data.data.timebao_accout;
            that.moveOutAmount = that.timebao_accout;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
      prevTimebao(){
          let page = this.timebaoDetails.page;
          if (page == 1){
            this.$message({
              message: this.$t('timeBao.alreadyFirstPage'),
              type: 'warning'
            });
          }else{
            this.timebaoDetails.page = page-1;
            this.getTimebaoDetails();
          }
        },
    nextTimebao(){
          let page = this.timebaoDetails.page;
          console.log(this.timebaoDetails.data.length);
          if ( this.timebaoDetails.data.length < 20){
            this.$message({
              message: this.$t('timeBao.alreadyLastPage'),
              type: 'warning'
            });
          }else{
            this.timebaoDetails.page = page+1;
            this.getTimebaoDetails();
          }
        },
    movein(){
        let that = this;

        let loadingInstance = Loading.service({ fullscreen: true });
        setTimeout(() => {
          loadingInstance.close();
        }, 500);

        let money = that.moveInAmount;
            that
              .$http({
                url: "/app/Timebao/move_in",
                method: "post",
                data: {
                  action: 'movein',
                  amount: money,
                },
                transformRequest: [(data) => JSON.stringify(data)]
              })
              
              .then(function (res) {
                if (res.data.status == 200) {
                  that.moveInState = false;
                  that.$message({
                    message: that.$t(res.data.msgId),
                    type: 'success',
                    onClose:function () {
                      // that.mainMethod();
                    }
                  });
                  that.mainMethod();
                } else {
                  that.$message.error(that.$t(res.data.msgId));
                }
              });
          
      },
    moveout(){
        let that = this;
        let loadingInstance = Loading.service({ fullscreen: true });
        setTimeout(() => {
          loadingInstance.close();
        }, 500);
        let money = that.moveOutAmount;
        that
              .$http({
                url: "/app/Timebao/move_out",
                method: "post",
                data: {
                  action: 'moveout',
                  amount: money,
                },
                transformRequest: [(data) => JSON.stringify(data)]
              })
              .then(function (res) {
                if (res.data.status == 200) {
                  that.moveOutState = false;
                  that.$message({
                    message: that.$t(res.data.msgId),
                    type: 'success',
                    onClose:function () {
                      // that.mainMethod();
                    }
                  });
                  that.mainMethod();
                } else {
                  that.$message.error(that.$t(res.data.msgId));
                }
              });
      },
      mainMethod(){
        this.getTimebaoFund();
        this.getTimebaoDetails();
        this.getUserinfo();
      },
      },
      created() {
      },
      mounted () {
        this.getTimeBaoImage();
        this.getTimebaoFund();
        this.getTimebaoDetails();
        this.getUserinfo();
      },
      beforeDestroy() {
        
      },
    }
</script>

<style scoped>
.headerTopBg {
  background-color: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 18px 20px;
}

.headerDetail {
  font-weight: normal;
  font-size: 14px;
  color: #f46f83;
}

.capital {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.capital p {
  font-size: 20px;
}

.capital h5 {
  font-size: 14px;
  font-weight: 300;
}
.box-card {
  border-radius: 15px;
  border: none;
}
.box-card>>>.el-card__header {
  background-color: #FFFFFF;
  border-radius: 15px;
  border: none;
}
.box-card>>>.el-card__body {
  background-color: #FFFFFF;
  border-radius: 15px;
  border: none;
}
.values-bar {
  background-color: var(--baseColor);
  border-radius: 10px;
  color: #FFFFFF;
  padding: 12px 10px;
}
.btn-white-bg {
  background-color: #FFFFFF;
  color: var(--baseColor);
  border-radius: 10px;
  padding: 14px 27px;
  font-size: 15px;
}

.btn-white-bg:hover,
.btn-blue-bg:hover {
  background-color: #FFFFFF !important;
  color: #ee5c35 !important;
}

.btn-blue-bg {
  background-color: var(--baseColor);
  color: #FFFFFF;
  border: 2px solid #FFFFFF;
  border-radius: 10px;
  padding: 14px 27px;
  font-size: 15px;
}
.integer-value {
  font-size: 24px;
  font-weight: 500;
}
.decimal-value {
  font-size: 17px;
  font-weight: 500;
  margin-left: -5px;
}
#inputField>>>.el-input__inner:focus {
  border-color: var(--baseColor) !important;
}

.dialog-cancel:hover {
  color: var(--baseColor) !important;
  border-color: var(--baseColor) !important;
  background-color: #fff !important;
  border-color: var(--baseColor) !important;
}
#inputField>>>.el-input__inner:hover {
  border-color: var(--baseColor) !important;
}
#inputField>>>.el-input__inner:active {
  border-color: var(--baseColor) !important;
}
#inputField>>>.el-range-editor.is-active {
  border-color: var(--baseColor) !important;
}
</style>

<style>
.timebao_popup .el-dialog {
  width: 20% !important;
}
#timeBaoTabs .el-tabs__active-bar {
  display: none;
  background-color: var(--baseColor);
}

#timeBaoTabs .el-tabs__item.is-active {
  color: var(--baseColor) !important;
}
#timeBaoTabs .el-tabs__item:hover {
  color: var(--baseColor) !important;
}

#timeBaoTabs .el-tabs__item.is-active:after {
  height: 4px;
  display: block;
  width: auto;
  background: var(--baseColor) !important;
  content: "";
  border-radius: 5px;
  width: 45px;
  display: block;
  margin: 0 auto;
  top: -4px;
  position: relative;
}
.el-date-table td.today span {
  color: var(--baseColor) !important;
}
.el-date-table td.end-date span, .el-date-table td.start-date span {
  background-color: var(--baseColor) !important;
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Timebao.vue